export const rootPaths = {
  root: '/',
  dashboardRoot: 'dashboard',
  configurationRoot: 'configuration',
  administationRoot: 'administration',
  reportesRoot: 'reportes',
  quejasRoot: 'quejas',
  authRoot: 'security'
};

export default {
  Cities: `/${rootPaths.configurationRoot}/municipios`,
  ReporteQuejas: `/${rootPaths.reportesRoot}/quejas`,
  ReporteQuejasPeriodo: `/${rootPaths.reportesRoot}/quejasperiodo`,
  QuejasIndex: `/${rootPaths.root}`,
  CodigosPostales: `/${rootPaths.configurationRoot}/cps`,
  TiposProductoQueja: `/${rootPaths.configurationRoot}/producttypes`,
  TiposViolacion: `/${rootPaths.configurationRoot}/violationtypes`,
  TiposEventos: `/${rootPaths.configurationRoot}/eventtypes`,
  TiposStatus: `/${rootPaths.configurationRoot}/statustypes`,
  TiposPlataforma: `/${rootPaths.configurationRoot}/tiposplataforma`,
  FormatosQueja: `/${rootPaths.administationRoot}/FormatosQueja`,
  Status: `/${rootPaths.configurationRoot}/status`,
  NewQueja: `/${rootPaths.quejasRoot}/New`,
  AddQueja: `/${rootPaths.quejasRoot}/Add`,
  Calendario: `/${rootPaths.quejasRoot}/Calendario`,
  CalendarioSem: `/${rootPaths.quejasRoot}/CalendarioSem`,
  DashboardAbiertas: `/${rootPaths.quejasRoot}/Abiertas`,
  QuejaDetails: `/${rootPaths.quejasRoot}/Detalle/:id`,
  ClasificacionQueja: `/${rootPaths.administationRoot}/clasifications`,
  ClasificacionQuejaWm: `/${rootPaths.administationRoot}/clasificationswm`,
  ClasificacionQuejaProfeco: `/${rootPaths.administationRoot}/clasificationsprofeco`,
  DelegacionesProfeco: `/${rootPaths.administationRoot}/delegations`,
  Customers: `/${rootPaths.administationRoot}/clientes`,
  Determinantes: `/${rootPaths.administationRoot}/determinantes`,
  Noms: `/${rootPaths.configurationRoot}/noms`,
  DetailCustomer: `/${rootPaths.administationRoot}/detallecliente`,
  Users: `/${rootPaths.authRoot}/Users`,
  simpleLogin: `/${rootPaths.authRoot}/login`,

  simpleLogout: `/${rootPaths.authRoot}/logout`
};
